// extracted by mini-css-extract-plugin
module.exports = {"color-checkbox":"ColorCheckbox_color-checkbox__2WoFm","unchecked":"ColorCheckbox_unchecked__2LLhl","checked":"ColorCheckbox_checked__3l9lS"};